<div class="booble-backdrop">
  <div class="xp-modal xp-modal-cadastro">
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm"
    >
      <div class="modal-content">
        <div class="modal-dialog-scrollable-general">
          <div class="modal-header">
            <div
              class="col-md-12 d-flex justify-content-between modal-header-border"
            >
              <div>
                <div class="modal-title-new">
                  Anexar comprovante da operação
                </div>
              </div>

              <div
                (click)="closeModal()"
                class="close-icon tappable align-self-center"
              >
                <img src="assets/image/close-modal-icon.svg" />
              </div>
            </div>
          </div>

          <div class="modal-body-content">
            <div
              class="box-document"
              [ngClass]="{
                'white-bg': proofOperationInput.files[0]?.name,
                'grey-bg': !proofOperationInput.files[0]?.name
              }"
              (click)="proofOperationInput.click()"
            >
              <input
                (change)="uploadDocumentsFile($event)"
                #proofOperationInput
                style="display: none"
                type="file"
              />

              <div
                *ngIf="!proofOperationInput.files[0]?.name"
                class="d-flex justify-content-center"
              >
                <img src="assets/image/upload-file.svg" />
              </div>
              <div
                *ngIf="!proofOperationInput.files[0]?.name"
                class="d-flex justify-content-center text-center mg-top-32"
              >
                <span id="txt-format">
                  Arraste o comprovante para cá ou
                  <span class="blue">busque nos seus <br />arquivos</span>
                </span>
              </div>

              <div
                *ngIf="!proofOperationInput.files[0]?.name"
                class="d-flex justify-content-center text-center"
              >
                <p id="txt-format">
                  Apenas os formatos .pdf .doc .png e .jpg são aceitos
                </p>
              </div>

              <div
                class="text-center mg-bottom-24"
                *ngIf="proofOperationInput.files[0]?.name"
              >
                <div class="d-flex justify-content-center">
                  <img src="assets/image/pdf-icon.svg" />
                </div>

                <div class="mg-top-24">
                  <p id="txt-file">
                    {{ proofOperationInput.files[0].name }}
                  </p>
                </div>

                <div class="mg-top-24">
                  <button
                    *ngIf="proofOperationInput.files[0]?.name"
                    mat-button
                    class="button danger mg-top-24"
                  >
                    Remover documento
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer-new" [style.justify-content]="'space-between'">
          <button
            type="button"
            [style.width]="'134px'"
            class="btn-outline-dark btn"
            type="button"
            (click)="closeModal()"
          >
            Fechar
          </button>
          <button
            type="button"
            [disabled]="!proofOperationFile"
            (click)="settlementConfirm()"
            class="btn-footer btn btn-dark-primary-blue"
            type="button"
          >
            Enviar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
